module.exports = __webpack_public_path__ + "top_page/industry-office-f01373422e34b27242da596e3028e57e.svg";